module.exports = __webpack_public_path__ + "static/img/11.bd86d86e.png";